/**
 * Version 1 of public Cross Flow API
 */

export const VERSION = 1;
export const createAPIv1 = onOpen => ({
  open(options) {
    return onOpen(options);
  }
});